import { createSlice } from "@reduxjs/toolkit";

export const topFilterSlice = createSlice({
  name: "topFilter",
  initialState: {
    value: "all",
  },
  reducers: {
    setTopFilter: (state, action) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setTopFilter } = topFilterSlice.actions;

export default topFilterSlice.reducer;
